import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;
const axios = createClient({ baseUrl, isAdminSite: true });

//benefits of membership
export const getMembershipBanner = (data) =>
  axios.post(`/membership-banner`, data);

export const updateMembershipBanner = (data) =>
  axios.post(`/membership-banners`, data);
export const getMembershipBenifit = (data) =>
  axios.post(`/membership-benefit`, data);
export const updateMembershipBenifit = (data) =>
  axios.post(`/membership-benefits`, data);
//membership highlight
export const getMembershipHighlightBanner = (data) =>
  axios.get(`/get_membership_banner`, data ? { params: data } : {});
export const addEditMembershipBanner = (data) =>
  axios.post(`/add_edit_membership_banner`, data);
export const getMembershipIntro = (data) =>
  axios.get(`/get_membership_intro`, data ? { params: data } : {});
export const getMembershipMemberList = (data) =>
  axios.post(`/get_membership_member_list`, data);
export const addEditMembershipIntro = (data) =>
  axios.post(`/add_edit_membership_intro`, data);
export const addEditMembershipMember = (data) =>
  axios.post(`/add_edit_membership_members`, data);
export const getEnableMembership = (data) =>
  axios.post(`/get_enabledmembership`, data);
export const getDisableMembership = (data) =>
  axios.post(`/get_disabledmembership`, data);

//membership categories
export const getMembershipCategoryBanner = (data) =>
  axios.post(`/membership-categories-banner`, data);
export const upsertMembershipCategoryBanner = (data) =>
  axios.post(`/membership-categories-banner-upsert`, data);
export const updateMembershipCategory = (data) =>
  axios.post(`/updatemembershipcategories`, data);

export const getMembershipCategory = (data) =>
  axios.post(`/membership-categorie`, data);
export const getCategoryMembersData = (data) =>
  axios.post(`/categories-members-data`, data);
export const membershipCategoryMember = (data) =>
  axios.post(`/membership-categories-member`, data);
export const getEnableCategories = (data) =>
  axios.post(`/get_enabledcategories`, data);
export const getDisableCategories = (data) =>
  axios.post(`/get_disabledcategories`, data);
export const deleteMembershipCategory = (data) =>
  axios.post(`/delete_membershipcategories`, data);

//get involved
export const getInvolvedBanner = (data) =>
  axios.get(`/get_getInvolved_banner`, data ? { params: data } : {});
export const getInvolvedsection = (data) =>
  axios.get(`/get_getInvolved_section`, data ? { params: data } : {});
export const addEditGetInvolved = (data) =>
  axios.post(`/add_edit_get_involved_banner`, data);
export const addEditGetInvolvedsection = (data) =>
  axios.post(`/add_edit_get_involved_section`, data);

// Members
export const getOnlineApplications = (data) =>
  axios.post(`/onlineapplication`, data);

export const getMembershipPayments = ({ userId, applicationId }) =>
  axios.get(`/membership-payments/${userId || 0}/${applicationId || 0}`);

export const getMeetingPayments = ({ userId }) =>
  axios.get(`/meeting-payments`, {
    params: { user_identifier: userId },
  });

export const getMembershipTypes = (data) => axios.get("/membership-types");

export const getPaymentStatuses = (data) => axios.get("/payment-statuses");
